import React from "react"

import { buttonVariants } from "@/components/ui/button"
import { cn } from "@/lib/utils"

type AuthLoginSubmitProps = React.ComponentProps<"button"> & {
  loading?: boolean
  /** When true, width hugs the label instead of stretching full field width. */
  fit?: boolean
}

/**
 * Native submit for auth forms — gradient CTA without Tessera Button chrome
 * (IBM Plex uppercase, bg-clip-padding). Styled like variant="gradient".
 */
export function AuthLoginSubmit({
  className,
  children,
  loading,
  disabled,
  fit = false,
  style,
  ...props
}: AuthLoginSubmitProps) {
  return (
    <button
      type="submit"
      data-auth-submit
      data-auth-submit-fit={fit ? "" : undefined}
      data-slot="auth-submit"
      data-variant="gradient"
      className={cn(
        buttonVariants({ variant: "gradient", size: "default" }),
        "auth-login-submit rounded-[6px] font-[family-name:var(--font-primary)] font-medium normal-case tracking-normal",
        fit ? "w-auto" : "w-full",
        className
      )}
      style={{
        borderWidth: 0,
        backgroundColor: "transparent",
        backgroundImage: "var(--gradient-primary)",
        color: "#ffffff",
        fontFamily: 'var(--font-primary), "Urbanist", sans-serif',
        textTransform: "none",
        letterSpacing: "normal",
        ...style,
      }}
      disabled={disabled || loading}
      {...props}
    >
      {children}
    </button>
  )
}
